/**
 * @namespace source.trash
 */
/**
 * @typedef Trash
 * @type Object
 */
import { toError } from './parsers/error';
import { MediaType } from '../../constants/MediaType';
export function initTrash(settings, http) {
  /**
   * @summary Remove all items in trash
   * @memberof source.trash
   * @param options
   * @returns {Promise}
   * @reject {Error}
   */
  function remove(options) {
    const url = settings.apiUrl + "/trash/delete";
    const data = {
      media_type: options.mediaType || MediaType.Picture,
      all_files: true
    };
    return http.post(url, data).catch(toError);
  }

  /**
   * @summary Restore all items in trash
   * @memberof source.trash
   * @param options
   * @returns {Promise}
   * @reject {Error}
   */
  function restore(options) {
    const url = settings.apiUrl + "/trash/restore";
    const data = {
      media_type: options.mediaType || MediaType.Picture,
      all_files: true
    };
    return http.post(url, data).catch(toError);
  }
  return {
    remove,
    restore
  };
}